import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

function ContactUs() {
  return (
    <>
      <Helmet>
        <title>Contact Us | Graham Care</title>
        <meta
          name="description"
          content="Contact Graham Care Group at Rodwell House, Addlestone, Surrey."
        />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section contact-us-page">
            <div className="contact-us-container">
              <h1>Contact Us</h1>

              <div className="contact-us-details">
                <address className="contact-us-details__address">
                  <p>Graham Care Group</p>
                  <p>Rodwell House</p>
                  <p>Row Town</p>
                  <p>Addlestone</p>
                  <p>Surrey</p>
                  <p>KT15 1HH</p>
                </address>

                <div className="contact-us-details__owner">
                  <p className="contact-us-details__label">Owner</p>
                  <p>Ernie Graham</p>
                  <p>
                    <a href="mailto:ernie@graham.care" className="nurse-care-link">
                      ernie@graham.care
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Graham Care <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Graham Care Ltd, KT15 1HH</p>
                <p>Copyright © Graham Care Ltd</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default ContactUs;
